export const ModulesMessages = {
    HOME_MODULE: 'Home',

    // MODULES
    MODULES_MODULE: 'Módulos',
    ACCOUNTS_PAGE: 'Cuentas',
    PQR_PAGE: 'Casos PQR',
    PQR_HISTORY_PAGE: 'Casos históricos PQR',
    INITIAL_CAUSALITY_PAGE: 'Causalidad inicial',
    GENERAL_PAGE: 'Casos información generales',
    SARLAFT_PAGE: 'Casos SARLAFT',
    SEARCH_CASE_PAGE: 'Búsqueda de casos',
    CASES_PAGE: 'Búsqueda de casos general',
    MODULES_PQR_MANAGEMENT: 'Gestión PQR',
    LEGAL_PROCEEDING: 'Procesos Judiciales',
    ALERTS_MODULE: 'Alertas PQR',
    SAMPLES_MODULE: 'Muestras PQR',
    EXPORT_MODULE: 'Exportar',
    REDIRECT_PAGE: 'Redirección PQR',
    MODULES_TYPIFICATIONS: 'Tipificaciones',
    FINAL_CAUSALITY_MODULE: 'Causalidad Final',
    USERS_MODULE: 'Usuarios',
    SYSTEM_CONFIGURATION_MODULE: 'Configuración del Sistema',
    MOTIVE_PAGE: 'Motivos',
};
